import { memo } from "react";
import type { BotezBokehComponentProps } from "./types";
import { CORAL_TEXT_LARGE, FONT_BODY, FONT_SCRIPT, TEAL, formatDate, getEventKind } from "./utils";

export const BotezBokehFooter = memo(({ event, config, locale, t }: BotezBokehComponentProps) => {
  const kind = getEventKind(event);
  const displayName = kind.isBaptismOnly
    ? kind.babyNames || event.name
    : kind.coupleNames || kind.babyNames || event.name;
  const yearLabel = event.date ? formatDate(event.date, locale, { year: "numeric" }) : "";

  return (
    <footer
      className="relative z-10 py-10 text-center border-t"
      style={{ background: config.palette.surfaceAlt, borderColor: `${TEAL}33` }}
    >
      <div className="max-w-4xl mx-auto px-6">
        <p
          className="text-2xl mb-2 break-words"
          style={{ fontFamily: FONT_SCRIPT, color: CORAL_TEXT_LARGE }}
        >
          {displayName}
        </p>
        <p
          className="text-sm opacity-80"
          style={{ fontFamily: FONT_BODY, color: config.palette.text }}
        >
          {[yearLabel, event.hashtag ? `#${event.hashtag.replace(/^#/, "")}` : ""].filter(Boolean).join(" · ")}
        </p>
        <p
          className="text-xs mt-3 opacity-80"
          style={{ fontFamily: FONT_BODY, color: config.palette.text }}
        >
          {t("events.form.template.madeWithLove")}
        </p>
      </div>
    </footer>
  );
});

BotezBokehFooter.displayName = "BotezBokehFooter";
